import React, { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { installMetaPixel } from './lib/metaPixel';
import { LandingPhase } from './components/phases/LandingPhase';
import { PersonalDataPhase } from './components/phases/PersonalDataPhase';
import { ThemePhase } from './components/phases/ThemePhase';
import { QuizPhase } from './components/phases/QuizPhase';
import { LoadingPhase } from './components/phases/LoadingPhase';
import { OfferPhase } from './components/phases/OfferPhase';
import { ThemeId } from './data/quizData';
type Phase = 'landing' | 'personalData' | 'theme' | 'quiz' | 'loading' | 'offer';
interface FormData {
  nombre_completo: string;
  fecha_nacimiento: string;
  signo_zodiacal: string;
  email: string;
  theme?: ThemeId;
  quizAnswers?: Record<string, string>;
}
export function App() {
  const [currentPhase, setCurrentPhase] = useState<Phase>('landing');
  const [formData, setFormData] = useState<FormData>({
    nombre_completo: '',
    fecha_nacimiento: '',
    signo_zodiacal: '',
    email: ''
  });
  // Install Meta Pixel + fire PageView and ViewContent.
  // Deferred + guarded so it never blocks or crashes the app.
  useEffect(() => {
    const id = setTimeout(() => {
      installMetaPixel();
    }, 0);
    return () => clearTimeout(id);
  }, []);
  const handlePersonalDataSubmit = (data: {
    nombre_completo: string;
    fecha_nacimiento: string;
    signo_zodiacal: string;
  }) => {
    setFormData(prev => ({
      ...prev,
      ...data
    }));
    setCurrentPhase('theme');
  };
  const handleThemeSelect = (themeId: ThemeId) => {
    setFormData(prev => ({
      ...prev,
      theme: themeId
    }));
    setCurrentPhase('quiz');
  };
  const handleQuizComplete = (answers: Record<string, string>) => {
    setFormData(prev => ({
      ...prev,
      quizAnswers: answers
    }));
    setCurrentPhase('loading');
  };
  return <div className="relative min-h-screen bg-[#0a0a0a] text-[#f4e9d1] font-eb selection:bg-gold/30 selection:text-gold-light" data-id="element-0">
      <div className="fixed inset-0 bg-radial-vignette pointer-events-none z-0" data-id="element-1" />
      <div className="bg-noise" data-id="element-2" />

      <main className="relative z-10 w-full min-h-screen flex flex-col" data-id="element-3">
        <AnimatePresence mode="wait" data-id="element-4">
          {currentPhase === 'landing' && <LandingPhase key="landing" onNext={() => setCurrentPhase('personalData')} data-id="element-5" />}

          {currentPhase === 'personalData' && <PersonalDataPhase key="personalData" onNext={handlePersonalDataSubmit} data-id="element-6" />}

          {currentPhase === 'theme' && <ThemePhase key="theme" onSelect={handleThemeSelect} data-id="element-7" />}

          {currentPhase === 'quiz' && formData.theme && <QuizPhase key="quiz" themeId={formData.theme} onComplete={handleQuizComplete} data-id="element-8" />}

          {currentPhase === 'loading' && <LoadingPhase key="loading" onComplete={() => setCurrentPhase('offer')} data-id="element-9" />}

          {currentPhase === 'offer' && formData.theme && <OfferPhase key="offer" formData={formData as any} data-id="element-10" />}
        </AnimatePresence>
      </main>
    </div>;
}